import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { MembershipDTOBase } from "./MembershipDTOBase";
import type { MembershipTypeMember } from "./MembershipTypeMember";
import type { MembershipTypeRef } from "./MembershipTypeRef";
import type { PersonMember } from "./PersonMember";
import type { PurchasableState } from "./PurchasableState";
import type { TrackedBase } from "./TrackedBase";

export class MembershipMember implements MembershipDTOBase, TrackedBase {
  constructor(public readonly assignId: number, public readonly personId: PersonMember | null, public readonly membershipTypeId: MembershipTypeMember | null, public readonly purchaseDate: Date | null, public readonly startDate: Date | null, public readonly expirationDate: Date | null, public readonly price: number, public readonly purchasableState: PurchasableState, public readonly voidCloseId: number | null, public readonly temp: boolean, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly membershipTypeIdTargetIds: MembershipTypeRef, public readonly membershipTypeName: string | null, public readonly programName: string | null) {
    this.cbiServiceContext = null;
    this.personIdLoaded = this.personId != null;
    this.personIdCached = this.personId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private personIdLoaded: boolean;
  private personIdCached: PersonMember | null;
  async personIdLazy(): Promise<PersonMember> {
    if (!this.personIdLoaded) {
      this.personIdCached = await this.cbiServiceContext!.membershipService().getMembershipMemberPersonId(this.assignId);
      this.personIdLoaded = true;
    }
    return this.personIdCached!;
  }
}
